import { Track } from "@/src/lib/tracking";
// 使用变量标记是否正在处理邮件打开请求，避免重复打开
// 这个变量在模块级别保存，不会影响其他功能
// 当用户快速多次点击时，这个机制能避免重复弹窗

let isProcessingEmail = false;

export function openEmailClient(to?: string, subject?: string, body?: string) {
  // 如果已经在处理一个邮件请求，则直接返回
  if (isProcessingEmail) {
    return;
  }

  isProcessingEmail = true;

  // 设置一个定时器，在短时间后重置状态
  // 这样即使打开邮件失败也不会导致永远无法打开
  setTimeout(() => {
    isProcessingEmail = false;
  }, 2000); // 2秒后重置

  const toEmail = to || "support@edgen.tech";
  // 构建邮件内容参数
  const params = {
    to: toEmail,
    subject: subject ? encodeURIComponent(subject) : "",
    body: body ? encodeURIComponent(body) : "",
  };

  // 创建一个不可见的a元素，使用点击方式触发mailto协议
  // 这种方式不会影响当前页面的路由
  const mailtoUrl = `mailto:${toEmail}?subject=${params.subject}&body=${params.body}`;
  const mailLink = document.createElement("a");
  try {
    mailLink.setAttribute("href", mailtoUrl);
    mailLink.style.display = "none";

    // 为了兼容性，必须先将元素添加到DOM中
    document.body.appendChild(mailLink);
    // 模拟点击事件
    mailLink.click();
  } catch (error) {
    // 使用log对象记录错误
    Track.error(error, {
      tag: "openEmailClient",
      msg: "Failed to open email client:",
    });
    // 错误情况直接打开Gmail
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${toEmail}&su=${params.subject}&body=${params.body}`;
    window.open(gmailUrl, "_blank", "noopener,noreferrer");
  } finally {
    // 无论成功与否，都从文档中移除元素
    document.body.removeChild(mailLink);
  }
}
